import Box from '@sendsprint/ui-react/dist/components/Box';
import React, { ReactNode } from 'react';
import cs from 'classnames';
import useMedia from '@src/hooks/utils/useMedia';
import AsideContent from './components/aside/asideContent';
import Aside from './components/aside';
import { Navigate, Outlet } from 'react-router-dom';
import { useBusinessCheckContext } from '@src/contexts/business-check-context';
import Loader from '@src/components/loader';
import { useAccount } from '@src/contexts';
import { Path } from '@src/navigations/routes';

interface Props {
  showAside?: boolean;
  asideContent?: ReactNode;
  isProtected?: boolean;
}

const AuthLayout = ({
  showAside = true,
  asideContent = <AsideContent />,
  isProtected = false
}: Props) => {
  const { isLoggedIn } = useAccount();
  const { isDesktop } = useMedia();
  const { resolvedPath } = useBusinessCheckContext();

  if (resolvedPath) {
    if (isProtected) {
      if (!isLoggedIn) {
        return <Navigate to={Path.Login} replace />;
      }
    }

    if (resolvedPath === 'loading') return <Loader />;
    return <Navigate to={resolvedPath} replace />;
  }

  return (
    <Box className="">
      <Outlet />
      {showAside && isDesktop && (
        <Box
          className={cs(
            ' ss-bg-primary1-500 ss-fixed ss-top-0 ss-right-0 ss-w-[350px] xl:ss-w-130 ss-h-screen',
            {
              'ss-hidden lg:ss-block': showAside,
              'ss-hidden': !showAside
            }
          )}>
          <Aside asideContent={asideContent} />
        </Box>
      )}
    </Box>
  );
};

export default AuthLayout;
